import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BulkOrderJobProgress } from "../../types/bulkOrderJobProgress";

interface BulkOrderJobState {
  activeJob: BulkOrderJobProgress | null;
  visible: boolean;
}

const initialState: BulkOrderJobState = {
  activeJob: null,
  visible: false,
};

export const bulkOrderJobSlice = createSlice({
  name: "bulkOrderJob",
  initialState,
  reducers: {
    setBulkOrderJobProgress(
      state,
      action: PayloadAction<BulkOrderJobProgress>,
    ) {
      state.activeJob = action.payload;
      state.visible = true;
    },
    dismissBulkOrderJobProgress(state) {
      state.activeJob = null;
      state.visible = false;
    },
  },
});

export const { setBulkOrderJobProgress, dismissBulkOrderJobProgress } =
  bulkOrderJobSlice.actions;

export default bulkOrderJobSlice.reducer;
